'use strict';

import React from 'react';
import Button from 'components/clarity-ui/inputs/button';
import ButtonGroup from 'components/clarity-ui/inputs/buttonGroup';

class QueryGroup extends React.Component {

  getGroupButtonDataState (connectorValue, value) {
    return connectorValue === value ? 'active' : 'inactive';
  }

  renderDeleteButton (handleOnClick) {
    return (
      <Button
        className='Small CustomWhite WithRed'
        onClick={handleOnClick}>
        Delete
      </Button>
    );
  }

  renderButtonGroupConnectors (item, handleButtonGroupOnClick) {
    return (
      <ButtonGroup>
        <Button
          className='Small CustomWhite WithBlue'
          style={{textTransform: 'uppercase'}}
          data-state={this.getGroupButtonDataState(item.connector, 'AND')}
          onClick={handleButtonGroupOnClick}
          value='AND'>And</Button>
        <Button
          className='Small CustomWhite WithBlue'
          style={{textTransform: 'uppercase'}}
          data-state={this.getGroupButtonDataState(item.connector, 'AND_NOT')}
          onClick={handleButtonGroupOnClick}
          value='AND_NOT'>And Not</Button>
        <Button
          className='Small CustomWhite WithBlue'
          style={{textTransform: 'uppercase'}}
          data-state={this.getGroupButtonDataState(item.connector, 'OR')}
          onClick={handleButtonGroupOnClick}
          value='OR'>Or</Button>
        {/*<Button
          className='Small CustomWhite WithBlue'
          style={{textTransform: 'uppercase'}}
          data-state={this.getGroupButtonDataState(item.connector, 'OR NOT')}
          onClick={handleButtonGroupOnClick}
          value='OR NOT'>Or Not</Button>*/}
      </ButtonGroup>
    );
  }

  render() {
    const { shoulDelete, item, handleAddRuleButtonOnClick,
      handleAddGroupButtonOnClick, handleDeleteButtonOnClick,
      handleButtonGroupOnClick } = this.props;

    return (
      <div className="EntityShowCase QueryGroup" name={item.name}>
        <div className="GroupButtons">
          <div className="BreakLine">
            <div className="Grid-cell--7of12">
              { this.renderButtonGroupConnectors (item, handleButtonGroupOnClick) }
            </div>
            <div className="Grid-cell--5of12">
              <ButtonGroup className="ElemRightAlign">
                <Button
                  className='Small CustomWhite WithGreen'
                  onClick={handleAddGroupButtonOnClick}>Add Group</Button>
                <Button
                  className='Small CustomWhite WithGreen'
                  onClick={handleAddRuleButtonOnClick}>Add Rule</Button>
                {!!shoulDelete ? this.renderDeleteButton(handleDeleteButtonOnClick) : null}
              </ButtonGroup>
            </div>
          </div>
        </div>
        <div className="GroupBody">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default QueryGroup;



// WEBPACK FOOTER //
// ./src/components/entityRecommender/queryBuilder/queryGroup.component.jsx